import * as yup from 'yup';
import {
  emailSchema,
  requiredErrorMessage,
  strongPasswordSchema,
  textSchema,
} from '@common/schema';

export const initialValues = {
  email: '',
  password: '',
  captcha_answer: '',
};

export const loginPasswordSchema = yup.object().shape({
  email: emailSchema.required(requiredErrorMessage),
  captcha_answer: textSchema
    .required(requiredErrorMessage)
    .max(5, 'The answer must be at most 5 characters'),
  password: strongPasswordSchema,
});
